<template>
    <div class="common-subject bjx-subject-details">
        <div class="common-detail-top">
            <img src="@/assets/images/s-bjx-details-top.jpg" alt />
            <!-- <MyCanvas :name="name"></MyCanvas> -->
            <img   class="bj-card-bg"  src="@/assets/images/bj-card-bg.png" alt />
            <a href="javascript:;" @click="applyCard" class="s-apply-button"></a>
            <!-- <a href="javascript:;" @click="e=>this.$router.push('/details/bjx')" class="go-back s-details-back"></a> -->
        </div>
        <div class="common-detail-main">
            <div class="common-equity bjx-equity">
                <div class="equity-content">
                    <SubjectTab :activeBlocks="$store.state.subjectBJXBlocks" :dataName="dataName"></SubjectTab>
                </div>
            </div>
            <div class="common-equity bjx-guide">
                <ul @click="routerGuide">
                    <li v-for="(item,index) in guideList" :key="index" :data-link="item.url" :data-status="item.status">
                        <img :src="item.image" alt />
                    </li>
                </ul>
            </div>
            <!-- 0125 hide -->
           
            <div class="common-equity tjx-charge-wrapper">
                <!-- <img class="table-bg" src="@/assets/images/tjx-table-bg.png" alt=""> -->
                <div class="common-activity-top tjx-activity-top">
                    <h3>收费标准</h3>
                </div>
                <div class="charge-content">
                    <div class="charge-table" :class="{active:isShow}">
                        <img class="table-src" src="@/assets/images/bjx-charge-table.png" alt />
                    </div>
                    <a href="javascript:;" class="more-rule subject-tjx-rule" @click="changeMoreRule"
                        v-show="!isShow">展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon tjx-collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="common-equity tjx-clause-wrapper" :class="{active:isRuleShow}">
                <img src="@/assets/images/tjx-clause-bg@2x.png" class="clause-bg" alt />
                <div class="common-activity-top tjx-clause-top">
                    <h3>条款及细则</h3>
                </div>
                <div class="tjx-clause-content m-4">
                    <p>世界白金鑫卡增值服务项目条款及细则</p>
                    <p>1. 世界白金鑫卡持卡人(以下简称“持卡人”)在激活世界白金鑫卡人民币银联尊尚白金卡后,上海农商银行(以下简称“我行”)将在3个工作日内为持卡人开通各项增值服务项目。</p>
                    <div class="common-other-content" v-show="isRuleShow">
                        <p>2. 除另有说明外,增值服务项目仅供持卡人本人享用。主卡和附属卡享受相同的增值服务。</p>
                        <p>3.
                            增值服务项目由我行指定的具有相关资质的供应商提供,并由供应商承担服务质量责任。我行除根据法律法规向客户提供商户的真实名称、地址和有效联系方式外,不介入客户与商户之间因购买商品或服务可能发生的各种纠纷。
                        </p>
                        <p>4. 在不对持卡人利益造成不利影响的前提下,我行有权适时调整增值服务项目的内容、供应商、条款及使用细则、相关费用、有效期等,并以网站公告、手机短信或账单提示方式通知持卡人。</p>
                        <p>5.
                            为便于向持卡人提供增值服务项目,我行将向相关供应商披露持卡人的个人信息。为保护客户的信息安全,我行将把上述信息披露控制在尽可能小的范围内,并要求供应商承担严格的保密责任。同时,在提供增值服务项目的过程中,供应商直接与持卡人核对个人信息,并负责采取必要的措施保存,保护个人信息。
                        </p>
                        <p>6. 持卡人申请世界白金鑫卡,即视为持卡人同意我行作为投保人,为持卡人(作为被保险人)投保相关保险,并与相关保险公司订立保险合同。</p>
                        <p>7.
                            持卡人享用增值服务项目,应以其世界白金鑫卡状态正常为前提。在持卡人的世界白金鑫卡状态不正常时,包括但不限于未缴纳年费、欠款逾期、账户被冻结、销卡销户、到期未续卡等,我行有权中止或终止向持卡人提供增值服务项目。
                        </p>
                        <p>8. 持卡人在有效期内销卡或者其世界白金鑫卡因状态不正常被我行中止或终止提供增值服务项目时,我行将不向持卡人退还相应年费,或者以其他任何方式向持卡人提供补偿。</p>
                        <p>9. 必要时,我行有权修改本条款及细则,并以网站公告、短信等方式提前通知客户,届时客户有权选择是否继续接受银行相关服务。</p>
                        <p>10.在法律许可范围内,上海农商银行有权修订本权益条款及细则,并经相关途径公告后生效。</p>
                    </div>
                    <a href="javascript:;" class="more-rule subject-tjx-rule" @click="changeMoreClause"
                        v-show="!isRuleShow">展开详情</a>
                    <div class="collect-wrap" v-show="isRuleShow">
                        <div class="collect-btn" @click="changeMoreClause">
                            <i class="collect-icon tjx-collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SubjectTab from "@/components/subjectTabbar.vue";
    import MyCanvas from "@/components/canvas.vue";
    export default {
        components: {
            SubjectTab,
            MyCanvas
        },
        data() {
            return {
                name: "bjx_d",
                dataName: "subjectBJXBlocks",
                isShow: false,
                id: "",
                isRuleShow: false,
                guideList: []
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            applyCard() {
                this.$emit("applyLink");
            },
            init() {
                this.guideList = this.$store.state.guideList["bjx"].guideList;
            },
            RouterPush(params) {
                this.$router.push({
                    name: params.name,
                    params: {
                        ...params
                    }
                });
            },
            actviePush(params) {
                // console.log(params.test);

                if (params.test) {
                    this.$test(params.test);
                }
                this.$router.push({
                    name: params.name,
                    params: {
                        name: params.id
                    },
                    query: params.query || {}
                });
            },
            routerGuide(e) {
                if (e.target.parentNode.nodeName === "LI") {
                    let link = e.target.parentNode.dataset.link;
                    let status = e.target.parentNode.dataset.status;
                    let path = link.split(/\//g);
                    let name = path[0];
                    let guide = path[1];
                    let id = path[2];
                    if (status !== "true") {
                        this.RouterPush({
                            name,
                            guide,
                            id
                        });
                    }
                }
            },
            changeMoreRule() {
                this.isShow = !this.isShow;
                // this.$test("HF a-detail-2");
            },
            changeMoreClause() {
                this.isRuleShow = !this.isRuleShow;
            },
            goBack() {
                this.$router.back();
            },
            // 近期热门活动
            goBtn() {
                this.$test('hot-activity')
                window.location.href = 'http://www.diyelf.com/srcb_hct/'
            }
        }
    };
</script>

<style  scoped>
.bj-card-bg{
    position:absolute
}
</style>